import { useEffect } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";

import Button from "../../../controls/Button";

const initialFValues = {
  name: "",
};

export default function ClassDetailsForm(props) {
  const {
    actionCall,
    allergenOptions,
    item,
    isEdit,
    setOpen,
    title,
    specSheetTestOptions,
  } = props;

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name.value === -1) {
        temp.name = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      actionCall(values);
    }
  };

  useEffect(() => {
    if (isEdit) {
      var testsSelected = [];
      if (item) {
        if (item.specSheetTests) {
          testsSelected = specSheetTestOptions.filter((el) =>
            item.specSheetTests.includes(el.value)
          );

          if (typeof testsSelected === "undefined") {
            testsSelected = { value: null };
          }
        }
      }

      var allergensSelected = [];
      if (item) {
        if (item.specSheetAllergens) {
          allergensSelected = allergenOptions.filter((el) =>
            item.specSheetAllergens.includes(el.value)
          );

          if (typeof allergensSelected === "undefined") {
            allergensSelected = { value: null };
          }
        }
      }

      setValues({
        ...item,
        specSheetTests: testsSelected,
        specSheetAllergens: allergensSelected,
      });
    }
  }, [item, setValues]);

  return (
    <form className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {title}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-accent"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6 space-y-4">
          <Input
            label="Name"
            name="name"
            required
            onChange={handleInputChange}
            value={values.name}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />

          <SelectMenu
            parentClass="col-span-2"
            handleInputChange={handleInputChange}
            name="specSheetTests"
            options={specSheetTestOptions}
            value={values.specSheetTests}
            title={"Tests"}
            error={errors.specSheetTests}
            showLabel={true}
            isMulti={true}
          />

          {/* <SelectMenu
            parentClass="col-span-2"
            handleInputChange={handleInputChange}
            name="specSheetAllergens"
            options={allergenOptions}
            value={values.specSheetAllergens}
            title={"Allergens"}
            error={errors.specSheetAllergens}
            showLabel={true}
            isMulti={true}
          /> */}
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <Button variant="secondary" onClick={() => setOpen({ childComponent: null, open: false })}>Cancel</Button>
        <Button type="submit" className="ml-4" onClick={handleSubmit}>{isEdit ? "Save" : "Create"}</Button>
      </div>
    </form>
  );
}
